import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoicesTable from "../components/InvoicesTable";

const InvoicesPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Faturalar" />
      <div className="card">
        <div className="card-body">
          <h5 className="card-title mb-4">Aktif Faturalar</h5>
          <InvoicesTable />
        </div>
      </div>
    </MasterLayout>
  );
};

export default InvoicesPage;

